import * as React from 'react';

import { useMoneySource } from './hooks';
import { MONEY_SOURCES_WIDGET_BY_TYPE } from './constants';

export const MoneySourceContainer = () => {
  const { isRender, widgetType, options, onChange } = useMoneySource();

  if (isRender) {
    const Widget = MONEY_SOURCES_WIDGET_BY_TYPE[widgetType];

    return <Widget options={options} onChange={onChange} />;
  }

  return null;
};
